import React from "react";
import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconCheck, IconCircle } from "@tabler/icons-react";
import { normalizeStatus } from "../../utils/hotelBookingUtils";

type Props = {
    status: string;
    language: "en" | "da";
};

export default function BookingStatusTimeline({ status, language }: Props) {
    const current = normalizeStatus(status);

    const steps = [
        {
            key: "pendingapproval",
            label: language === "en" ? "Submitted" : "Sendt",
        },
        {
            key: "awaitingpayment",
            label: language === "en" ? "Approved" : "Godkendt",
        },
        {
            key: "paid",
            label: language === "en" ? "Paid" : "Betalt",
        },
        {
            key: "roomassignmentopen",
            label: language === "en" ? "Rooming list" : "Rooming list",
        },
        {
            key: "completed",
            label: language === "en" ? "Completed" : "Afsluttet",
        },
    ];

    const currentIndex = steps.findIndex((x) => x.key === current);

    function isDone(index: number) {
        if (current === "completed") return true;
        return currentIndex >= 0 && index <= currentIndex;
    }

    if (current === "rejected" || current === "cancelled") {
        return (
            <Text size="xs" c="red" fw={700}>
                {language === "en" ? "Booking is no longer active" : "Bookingen er ikke længere aktiv"}
            </Text>
        );
    }

    return (
        <Group gap="xs" wrap="wrap">
            {steps.map((step, index) => {
                const done = isDone(index);

                return (
                    <Group key={step.key} gap={5}>
                        <ThemeIcon
                            size="sm"
                            radius="xl"
                            color={done ? "blue" : "gray"}
                            variant={done ? "filled" : "light"}
                        >
                            {done ? <IconCheck size={12} /> : <IconCircle size={10} />}
                        </ThemeIcon>

                        <Text size="xs" c={done ? "blue" : "dimmed"} fw={done ? 700 : 500}>
                            {step.label}
                        </Text>
                    </Group>
                );
            })}
        </Group>
    );
}
